import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const createSubChannel = createAsyncThunk("createSubChannel", async ({ channel_id, values }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post(`channel/${channel_id}/sub_channel`, values);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const CreateSubChannelSlice = createSlice({
	name: "CreateSubChannelSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetCreateSubChannelState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(createSubChannel.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(createSubChannel.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(createSubChannel.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetCreateSubChannelState } = CreateSubChannelSlice.actions;
export default CreateSubChannelSlice.reducer;
